import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TasksIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M17.8333 5.4H14.35C14 4.443 13.0833 3.75 12 3.75C10.9167 3.75 10 4.443 9.65 5.4H6.16667C5.25 5.4 4.5 6.1425 4.5 7.05V18.6C4.5 19.5075 5.25 20.25 6.16667 20.25H17.8333C18.75 20.25 19.5 19.5075 19.5 18.6V7.05C19.5 6.1425 18.75 5.4 17.8333 5.4ZM12 5.4C12.4583 5.4 12.8333 5.77125 12.8333 6.225C12.8333 6.67875 12.4583 7.05 12 7.05C11.5417 7.05 11.1667 6.67875 11.1667 6.225C11.1667 5.77125 11.5417 5.4 12 5.4ZM13.6667 16.95H7.83333V15.3H13.6667V16.95ZM16.1667 13.65H7.83333V12H16.1667V13.65ZM16.1667 10.35H7.83333V8.7H16.1667V10.35Z'
                fill='currentColor'
            />
        </>
    ),
})

TasksIcon.displayName = 'TasksIcon'
